export const MAX_EXPORT_ROWS = 100000;
export const MAX_EXPORT_CELL_LENGTH = 32767;
export function safeCsvCell(value) {
    return typeof value === 'string' && /^[\s]*[=+@-]/.test(value) ? `'${value}` : value;
}
export function validateExportTables(tables) {
    if (tables.length === 0)
        throw new Error('Choose at least one dataset to export.');
    const ids = new Set();
    let rows = 0;
    for (const table of tables) {
        if (ids.has(table.id))
            throw new Error('Export datasets must have unique IDs.');
        ids.add(table.id);
        if (table.columns.length === 0)
            throw new Error(`Choose columns for ${table.label}.`);
        rows += table.rows.length;
        if (rows > MAX_EXPORT_ROWS) {
            throw new Error(`Exports support up to ${MAX_EXPORT_ROWS.toLocaleString('en-US')} rows. Narrow your selection or call date range.`);
        }
        for (const row of table.rows) {
            if (row.length !== table.columns.length)
                throw new Error(`Invalid row in ${table.label}.`);
            for (const cell of row) {
                if (typeof cell === 'string' && cell.length > MAX_EXPORT_CELL_LENGTH) {
                    throw new Error(`A value in ${table.label} exceeds the spreadsheet cell limit. Export less text or use transcript rows.`);
                }
                if (typeof cell === 'number' && !Number.isFinite(cell))
                    throw new Error(`Invalid number in ${table.label}.`);
            }
        }
    }
}
